<template>
    <div id="placement-preference">
        <v-card-title class="pb-0">
            <v-icon :color="kingsGold" left>mdi-home-edit</v-icon> Placement Preference
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-account-multiple</v-icon>Cluster Placement
                    <br>
                    Residents can be placed in a unit with students who share similar interest (see Interest
                    Groups below in First Choice, Second Choice and Third Choice).
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-select v-model="item.clusterPlacement" :items="clusterPlacementItems"
                            label="Cluster Placement" placeholder="Not Available" readonly>
                        </v-select>
                    </v-col>
                </v-row>
                <v-card-subtitle v-if="item.clusterPlacement == 'Interested'" class="px-0">
                    <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Cluster Placement
                    Preference
                    <br>
                    If you are interested in such a placement, please indicate your first, second and third
                    choices for placement clusters.
                </v-card-subtitle>
                <v-row v-if="item.clusterPlacement == 'Interested'">
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice01" label="First Choice" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice02" label="Second Choice" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.clusterChoice03" label="Third Choice" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle v-if="item.clusterPlacement == 'Interested'" class="px-0">
                    <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Building Preference OR
                    Cluster Placement
                    <br>
                    If we find that we can accommodate only your building preference OR your cluster placement,
                    which is most important to you?
                </v-card-subtitle>
                <v-row v-if="item.clusterPlacement == 'Interested'">
                    <v-col cols="12">
                        <v-select v-model="item.clusterBuildingPreference" hide-details
                            :items="clusterBuildingPreferenceItems" label="Most Important" placeholder="Not Available"
                            readonly>
                        </v-select>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-head-heart</v-icon>Lifestyle (Please check all that
                    apply)
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I expect to get up before 9AM on weekdays" multiple
                            value="I expect to get up before 9AM on weekdays" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details label="I usually stay up past midnight"
                            multiple value="I usually stay up past midnight" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="Any kind of noise distracts me while im studying" multiple
                            value="Any kind of noise distracts me while im studying" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I like to study with background noise" value="I like to study with background noise"
                            readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I want my room to be a gathering place for friends" multiple
                            value="I want my room to be a gathering place for friends" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I prefer not to have many visitors in my room" multiple
                            value="I prefer not to have many visitors in my room" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I plan to maintain a fitness program" multiple
                            value="I plan to maintain a fitness program" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I plan to tryout for a visitor sports team" multiple
                            value="I plan to tryout for a visitor sports team" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I have toured/visited the residences at King's Unversity College" multiple
                            value="I have toured/visited the residences at King's Unversity College" readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I would like to be involved in the Residence Council or King's University College Student Council"
                            multiple
                            value="I would like to be involved in the Residence Council or King's University College Student Council"
                            readonly>
                        </v-checkbox>
                        <v-checkbox v-model="item.lifestyle" dense hide-details
                            label="I am a smoker (Please be advised that smoking is NOT permitted in any residence building)"
                            multiple value="I am a smoker" readonly>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-bed</v-icon>My room is
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="item.lifestyleMyRoomIs" readonly>
                            <v-radio v-for="(item, index) in lifestyleMyRoomIsItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.applicantInterests" auto-grow counter="512" hide-details
                            label="My Personal Interests" placeholder="None" readonly outlined>
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-human-greeting</v-icon>Tour Room
                    <br>
                    Residents have the opportunity to apply to be a tour room for prospective students and be
                    paid an honorarium for this role. As a tour room, your role will be to show your room to
                    students who are touring King's residence as they consider applying' to King's, and act as a
                    King's ambassador. If you are interested in this role, please indicate this by selecting
                    <b>YES</b> below.
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="item.tourRoom" readonly>
                            <v-radio v-for="(item, index) in tourRoomItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'application-building-preference',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            clusterBuildingPreferenceItems: [{
                    text: 'Being placed in my first building preference',
                    value: 'Building'
                },
                {
                    text: 'Being placed in the cluster group of my choice (1st or 2nd choice)',
                    value: 'Cluster'
                }
            ],
            clusterPlacementItems: [{
                    text: 'I am interested in a cluster placement',
                    value: 'Interested'
                },
                {
                    text: 'I am NOT interested in a cluster placement',
                    value: 'Not interested'
                }
            ],
            lifestyleMyRoomIsItems: [{
                    text: 'Very neat',
                    value: '1'
                },
                {
                    text: '2',
                    value: '2'
                },
                {
                    text: '3',
                    value: '3'
                },
                {
                    text: '4',
                    value: '4'
                },
                {
                    text: '5',
                    value: '5'
                },
                {
                    text: '6',
                    value: '6'
                },
                {
                    text: '7',
                    value: '7'
                },
                {
                    text: '8',
                    value: '8'
                },
                {
                    text: '9',
                    value: '9'
                },
                {
                    text: 'Very messy',
                    value: '10'
                }
            ],
            tourRoomItems: [{
                    text: 'YES, I am interested in this role',
                    value: 'Yes'
                },
                {
                    text: 'NO, I am not interested in this role',
                    value: 'No'
                }
            ],
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}

.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>